import clsx from 'clsx';
import React from 'react';

import imgRectangleLeft from 'images/pro/rectangle-left.svg';
import imgRectangleRight from 'images/pro/rectangle-right.svg';

import useCurrentUser from '@hooks/useCurrentUser';
import { subscribe_promotion_path, upgrade_subscription_path } from '@routes';
import {
  DEFAULT_ANNUAL_OFFER_CODE,
  DEFAULT_MONTHLY_OFFER_CODE,
  DEFAULT_PRO_OFFER_CODE,
  DEFAULT_YP_OFFER_CODE,
} from '@src/constants';

const ProFooterCallout = () => {
  const { currentUser } = useCurrentUser();
  const isCurrentUserSubscriber = currentUser?.is_subscriber;
  const isCurrentUserProSubscriber = currentUser?.is_pro_subscriber;

  return (
    <div className="relative bg-secondary-pink px-16 py-40 text-center xs:px-48">
      <div className="relative z-[1]">
        <p className="m-0 font-sans text-overline uppercase text-primary-red">
          {isCurrentUserSubscriber && !isCurrentUserProSubscriber
            ? 'Upgrade now'
            : !isCurrentUserSubscriber && 'Subscribe'}
        </p>
        <p className="m-0 mt-8 font-serif text-headline-sm text-primary-black md:mt-16 md:text-headline-lg">
          The Information Pro.
          <br />
          Don{'’'}t take a meeting without it.
        </p>
        {!isCurrentUserProSubscriber && (
          <a
            href={
              isCurrentUserSubscriber
                ? upgrade_subscription_path()
                : subscribe_promotion_path({
                    offer: `${DEFAULT_PRO_OFFER_CODE},${DEFAULT_ANNUAL_OFFER_CODE},${DEFAULT_MONTHLY_OFFER_CODE},${DEFAULT_YP_OFFER_CODE}`,
                  })
            }
            className={clsx(
              'bg-primary-red font-sans text-button-md uppercase !text-white',
              'mx-auto mt-16 flex h-40 items-center justify-center rounded-r-2 xs:w-[245px] md:mt-32',
              'transition-colors hover:bg-pro-red focus:bg-pro-red'
            )}
          >
            {isCurrentUserSubscriber ? 'Go Pro' : 'Get Started'}
          </a>
        )}
      </div>
      <div className="absolute -top-px left-0 w-[133px] xs:w-[200px] sm:w-[300px] md:w-[416px]">
        <img className="block w-full object-contain object-top" src={imgRectangleLeft} alt="" />
      </div>
      <div className="absolute -bottom-px right-0 w-[133px] xs:w-[200px] sm:w-[300px] md:w-[416px]">
        <img className="block w-full object-contain object-top" src={imgRectangleRight} alt="" />
      </div>
    </div>
  );
};

export default ProFooterCallout;
